import { useMutation } from '@tanstack/react-query';
import type { CandidateEndpointBulkProgressPostRequest } from '../types/CandidateProfile';

export default function usePostCandidateEndpointBulkProgress() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ candidateProfileId, ids }: CandidateEndpointBulkProgressPostRequest) => {
      const response = await fetch(
        `/agent/api/candidate_endpoints/${candidateProfileId}/bulk_progress`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          body: JSON.stringify({ ids }),
        }
      );
      const data = await response.json();
      return data;
    },
  });
}
